import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { IconArrowRight } from '@wds/icons';
import { Typography } from '@wds/typography';
import { NavRouteParams } from '~pricing/components/Navigation/types';

import COPY from '~app/pages/Pricing/copy';
import BackToSummary from '~pricing/components/BackToSummary';
import DetailsPackagesView from '~pricing/components/DetailsPackagesView';
import MainHeading from '~pricing/components/MainHeading';
import Navigation from '~pricing/components/Navigation';
import DetailsFooter from '~pricing/components/PricingFooter';
import useTrackingDetails from '~pricing/hooks/useTrackingDetails';
import { usePricingState } from '~shared/hooks/usePricingState';

import useEducationalStyles from './useStyles';
import EduContext from '~shared/hooks/eduContext';
import { ROOT_PRICING_ROUTE } from '~shared/constants/pricing';

export default function EducationalDetailsPage(): JSX.Element {
  const { ViewPricingLink } = useEducationalStyles();
  const { canonicalPath } = useParams<NavRouteParams>();
  const {
    state: {
      packages: { displayPackages, discountInfo },
    },
  } = usePricingState();
  const { pageUtSource } = useTrackingDetails();

  const path = canonicalPath === 'educational' ? 'individual' : canonicalPath;
  const viewPricingLinkText = t(COPY.VIEW_PRICING);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isEduValue = useMemo(
    () => ({
      isEdu: true,
    }),
    []
  );

  return (
    <div key="PricingEducational">
      <header>
        <BackToSummary url={createURL(`${ROOT_PRICING_ROUTE}/${path}`, { ut_source: pageUtSource })} />
        <MainHeading>{t(COPY.EDUCATIONAL_HEADING)}</MainHeading>
        <Typography align="center" data-testid="Educational__SubHeading">
          {t(COPY.EDUCATIONAL_SUBHEADING)}{' '}
          <Link
            className={ViewPricingLink}
            to={createURL(`${ROOT_PRICING_ROUTE}/individual/details/`, { ut_source: pageUtSource })}
          >
            {viewPricingLinkText}
            <IconArrowRight title={viewPricingLinkText} size="sm" />
          </Link>
        </Typography>
        <Navigation />
      </header>
      <EduContext.Provider value={isEduValue}>
        <DetailsPackagesView packageData={displayPackages} discountInfo={discountInfo} />
      </EduContext.Provider>
      <DetailsFooter packages={displayPackages} />
    </div>
  );
}
